import { GetProductGroupsResponse, WholesaleCatalogType } from '@cbgms/api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useQuery } from '@cbgms/base/http/use-query'
import { getAllProductTrees } from 'app-support/productgroup/state/actions'
import { Dropdown } from '@carsys/form'
import { useFormikContext } from 'formik'
import { IFormValues } from './types'
import { isRequired } from '@cbgms/base/utils/validations'
import { IDropdownOption } from '@carsys/ui'

export const hasCarsysFields = (selectedCatalogType: WholesaleCatalogType) =>
  Boolean(selectedCatalogType === WholesaleCatalogType.CARSYS_PRODUCT_TREE || selectedCatalogType === WholesaleCatalogType.EMDM)

export const CatalogFieldsCarsys = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    values: { wholesaleCatalogType }
  } = useFormikContext<IFormValues>()

  const { data: productTreeOptions } = useQuery(['CatalogFieldsCarsys', 'getAllProductTrees'], async () => {
    const { Data } = (await dispatch(getAllProductTrees({ fields: 'ProductGroupTranslation.Name' }))) as any as GetProductGroupsResponse
    return Data?.map<IDropdownOption>(item => ({
      key: item.ProductGroup.UUID,
      text: item.ProductGroupTranslation.Name,
      value: item.ProductGroup.UUID
    }))
  })

  const renderProductTreeInput = useMemo(() => hasCarsysFields(wholesaleCatalogType), [wholesaleCatalogType])
  if (!renderProductTreeInput || !productTreeOptions) return null

  return (
    <Dropdown
      label={t('wholesale.productgroup')}
      data-testid='product-tree-input'
      name='CarsysProductTreeUUID'
      required
      validate={isRequired}
      options={productTreeOptions || undefined}
    />
  )
}
